






















import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'OutputTable',
  setup() {
    let outputs = ref<string[]>([])
    let tableHeightRef = ref<string>()
    const blockImgs: { [key: string]: string } = {
      ヒト: '/img/pose_blocks/table_pose_human.png',
      ライオン: '/img/pose_blocks/table_pose_lion.png',
      トリ: '/img/pose_blocks/table_pose_bird.png',
      ウサギ: '/img/pose_blocks/table_pose_rabbit.png',
    }
    function updateTableHeight(height: string): void {
      tableHeightRef.value = height
    }
    function setOutputs(o: string[] | undefined): void {
      if (o) {
        outputs.value = o
      }
    }
    return {
      tableHeightRef,
      outputs,
      setOutputs,
      updateTableHeight,
      blockImgs,
    }
  },
})
